import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { useTranslation } from "react-i18next";
import { staffDeductionText } from "./staff-deductions-language";

export default function StaffDeductionPhoto({id}:{id:string}){
  const {currentWorkspace}=useAuth(),{i18n}=useTranslation(),rtl=i18n.language==="ar",text=(s:string)=>staffDeductionText(s,rtl);
  const [src,setSrc]=useState(""),[error,setError]=useState(false),[retry,setRetry]=useState(0);
  useEffect(()=>{
    let alive=true,url="";
    const controller=new AbortController();setSrc("");setError(false);
    void fetch(`/api/cash/staff-deductions/${encodeURIComponent(id)}/proof`,{credentials:"include",headers:{"x-workspace-id":currentWorkspace?.id||""},signal:controller.signal}).then(async response=>{
      if(!response.ok)throw new Error("Photo unavailable");
      const blob=await response.blob();
      if(alive){url=URL.createObjectURL(blob);setSrc(url)}
    }).catch(()=>{if(alive)setError(true)});
    return()=>{alive=false;controller.abort();if(url)URL.revokeObjectURL(url)};
  },[id,currentWorkspace?.id,retry]);
  return error?<div className="note bad" role="alert">{rtl?"تعذّر تحميل الصورة":"Could not load photo"}<button type="button" className="btn" onClick={()=>setRetry(v=>v+1)}>{text("Retry")}</button></div>:src?<a href={src} target="_blank" rel="noreferrer"><img className="staff-pay-proof" src={src} alt={rtl?"صورة إثبات الخصم":"Deduction evidence photo"} /></a>:<div className="staff-loading" role="status" aria-label={text("Loading")} />;
}
